import React from "react";
import ReactDOM from "react-dom";
import { GlobalStyle } from "@mzt-monorepo/mzt-atomic";
import { Provider } from "react-redux";
import App from "./app";
import store from "./redux/store";

ReactDOM.render(
  <React.StrictMode>
    <GlobalStyle />
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
